import { useContext, useState } from "react";
import CustomCheckbox from "../UI/CustomCheckbox/CustomCheckbox";
import CustomLink from "../UI/CustomLink/CustomLink";
import PrimaryInput from "../UI/PrimaryInput/PrimaryInput";
import LoadingScreen from "../UI/LoadingScreen/LoadingScreen";
import LoginButton from "../UI/LoginButton/LoginButton";
// import MessageBox from "../UI/MessageBox/MessageBox";
import Logo from "../UI/Logo/Logo";
import { AuthContext } from "../../context/authContext";
import axios from "axios";
import classes from "./Login.module.scss";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const authContext = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [message, setMessage] = useState(null);
  const [keepLogin, setKeepLogin] = useState(false);

  const checkboxChangeHandler = () => {
    setKeepLogin((oldState) => !oldState);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    setIsLoading(true);
    // setMessage(null);

    axios
      .post("/login", { email, password })
      .then((res) => {
        authContext.login(res.data, res.data.token);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err.response.data.message || "Unable to authenticate!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  return (
    <div className={classes.Login}>
      <LoadingScreen show={isLoading} />
      <ToastContainer />
      {/* {message && <MessageBox message={message.message} type={message.type} />} */}
      <form onSubmit={formSubmitHandler} className={classes.LoginForm}>
        <Logo />
        <h2 className={classes.LoginHeader}>Log in.</h2>
        <p className={classes.LoginParagraph}>
          Log in with your data that you entered during your registration.
        </p>
        <PrimaryInput
          label="Your e-mail"
          type="email"
          placeholder="vijay@jalebi.io"
          value={email}
          onChanged={(e) => setEmail(e.target.value)}
          customClasses="mb-3-2"
          required
        />
        <PrimaryInput
          label="Password"
          type="password"
          placeholder="****"
          value={password}
          onChanged={(e) => setPassword(e.target.value)}
          required
        />
        <div className="mt-1-6 mb-1-2 text-end">
          <CustomLink link="/forget-password" text="Forgot Password?" />
        </div>
        <CustomCheckbox
          name="login"
          value="keeplogin"
          text="Keep me logged in"
          isChecked={keepLogin}
          onChanged={checkboxChangeHandler}
        />
        <LoginButton
          customClasses="mt-4-8 mb-1-6 w-full"
          type="submit"
          text="Log in"
        />
        <div className={classes.NoAccountDiv}>
          <span>Dont have an account? </span>
          <CustomLink link="/signup" text="Sign up" />
        </div>
      </form>
      <div className={classes.SideImage}></div>
    </div>
  );
};

export default Login;
